import axios from "axios";
import Config from "../utils/Config";

class RequestTypeMangementService {
    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    async getRequestTypeList(companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.get(
            Config.BACKEND_URL + '/api/approvalRequest/requestTypes',
            this.config
        )
        return data.data;
    }

    async createRequestType(companyId, accessToken, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.post(
            Config.BACKEND_URL + '/api/approvalRequest/createRequestType',
            formData,
            this.config
        )
        return data.data;
    }

    async updateRequestType(companyId, accessToken, requestTypeId, formData) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.patch(
            Config.BACKEND_URL + `/api/approvalRequest/requestType/${requestTypeId}`,
            formData,
            this.config
        )
        return data.data;
    }

    async deleteRequestType(companyId, accessToken, requestTypeId) {
        this.setAccessToken(accessToken, companyId);
        const data = await axios.delete(
            Config.BACKEND_URL + `/api/approvalRequest/requestType/${requestTypeId}`,
            this.config
        )
        return data.data;
    }
}


export default new RequestTypeMangementService();

